// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Release Table Drawer ───────────────────────────────── */
.rtd-shell {
  position: absolute;
  top: 0;
  right: 0;
  width: 80vw;
  height: 100vh;
  background: #ffffff;
  border-radius: 0;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.28);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: rtdDrawerIn 220ms ease-out;
  outline: none;
}

/* Header */
.rtd-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 16px 20px 14px;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.rtd-supertitle {
  display: block;
  font-size: 11px !important;
  font-weight: 600;
  color: #6b7280;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  margin-bottom: 3px;
}

.rtd-title {
  margin: 0;
  font-size: 22px !important;
  font-weight: 700;
  color: #111827;
  line-height: 1.2;
}

.rtd-close {
  background: none;
  border: none;
  font-size: 18px;
  color: #6b7280;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  line-height: 1;
  margin-top: 2px;
}

.rtd-close:hover {
  background: #f3f4f6;
  color: #111827;
}

/* Body */
.rtd-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 28px;
  gap: 14px;
  text-align: center;
}

/* Icon circle */
.rtd-icon-wrap {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #fee2e2;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

/* Text */
.rtd-confirm-title {
  margin: 0;
  font-size: 20px !important;
  font-weight: 700;
  color: #111827;
}

.rtd-confirm-sub {
  margin: 0;
  font-size: 14px !important;
  color: #6b7280;
  max-width: 320px;
  line-height: 1.5;
}

/* Actions */
.rtd-actions {
  display: flex;
  gap: 12px;
  width: 100%;
  margin-top: 12px;
}

.rtd-btn-cancel,
.rtd-btn-confirm {
  flex: 1;
  height: 48px;
  border-radius: 999px;
  font-size: 15px !important;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, opacity 0.15s;
}

.rtd-btn-cancel {
  background: #ffffff;
  border: 1.5px solid #d1d5db;
  color: #374151;
}

.rtd-btn-cancel:hover:not(:disabled) {
  background: #f9fafb;
}

.rtd-btn-confirm {
  background: #dc2626;
  border: none;
  color: #ffffff;
}

.rtd-btn-confirm:hover:not(:disabled) {
  background: #b91c1c;
}

.rtd-btn-cancel:disabled,
.rtd-btn-confirm:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Slide-in animation */
@keyframes rtdDrawerIn {
  from {
    transform: translateX(100%);
    opacity: 0.98;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@media (max-width: 600px) {
  .rtd-shell {
    width: 100vw;
    border-radius: 0;
  }
}

/* ═══ DARK THEME — ReleaseTableDrawer ═══ */
.dark .rtd-shell {
  background: #1e293b;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.5);
}
.dark .rtd-header { border-bottom-color: #334155; }
.dark .rtd-supertitle { color: #64748b; }
.dark .rtd-title    { color: #f1f5f9; }
.dark .rtd-close    { color: #64748b; }
.dark .rtd-close:hover { background: #334155; color: #e2e8f0; }
.dark .rtd-icon-wrap { background: #4c0519; }
.dark .rtd-confirm-title { color: #f1f5f9; }
.dark .rtd-confirm-sub   { color: #94a3b8; }
.dark .rtd-btn-cancel {
  background: #1e293b;
  border-color: #334155;
  color: #e2e8f0;
}
.dark .rtd-btn-cancel:hover:not(:disabled) { background: #334155; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/table-layout/components/ReleaseTableDrawer/ReleaseTableDrawer.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,qCAAqC;EACrC,aAAa;AACf;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,OAAO;EACP,YAAY;EACZ,oBAAoB;EACpB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE;IACE,2BAA2B;IAC3B,aAAa;EACf;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA,4CAA4C;AAC5C;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;AACA,oBAAoB,4BAA4B,EAAE;AAClD,wBAAwB,cAAc,EAAE;AACxC,sBAAsB,cAAc,EAAE;AACtC,sBAAsB,cAAc,EAAE;AACtC,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;AAC9D,uBAAuB,mBAAmB,EAAE;AAC5C,2BAA2B,cAAc,EAAE;AAC3C,2BAA2B,cAAc,EAAE;AAC3C;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA,6CAA6C,mBAAmB,EAAE","sourcesContent":["/* ── Release Table Drawer ───────────────────────────────── */\n.rtd-shell {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 80vw;\n  height: 100vh;\n  background: #ffffff;\n  border-radius: 0;\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.28);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  animation: rtdDrawerIn 220ms ease-out;\n  outline: none;\n}\n\n/* Header */\n.rtd-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 16px 20px 14px;\n  border-bottom: 1px solid #e5e7eb;\n  flex-shrink: 0;\n}\n\n.rtd-supertitle {\n  display: block;\n  font-size: 11px !important;\n  font-weight: 600;\n  color: #6b7280;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  margin-bottom: 3px;\n}\n\n.rtd-title {\n  margin: 0;\n  font-size: 22px !important;\n  font-weight: 700;\n  color: #111827;\n  line-height: 1.2;\n}\n\n.rtd-close {\n  background: none;\n  border: none;\n  font-size: 18px;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 6px;\n  line-height: 1;\n  margin-top: 2px;\n}\n\n.rtd-close:hover {\n  background: #f3f4f6;\n  color: #111827;\n}\n\n/* Body */\n.rtd-body {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 32px 28px;\n  gap: 14px;\n  text-align: center;\n}\n\n/* Icon circle */\n.rtd-icon-wrap {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  background: #fee2e2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 8px;\n}\n\n/* Text */\n.rtd-confirm-title {\n  margin: 0;\n  font-size: 20px !important;\n  font-weight: 700;\n  color: #111827;\n}\n\n.rtd-confirm-sub {\n  margin: 0;\n  font-size: 14px !important;\n  color: #6b7280;\n  max-width: 320px;\n  line-height: 1.5;\n}\n\n/* Actions */\n.rtd-actions {\n  display: flex;\n  gap: 12px;\n  width: 100%;\n  margin-top: 12px;\n}\n\n.rtd-btn-cancel,\n.rtd-btn-confirm {\n  flex: 1;\n  height: 48px;\n  border-radius: 999px;\n  font-size: 15px !important;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s, opacity 0.15s;\n}\n\n.rtd-btn-cancel {\n  background: #ffffff;\n  border: 1.5px solid #d1d5db;\n  color: #374151;\n}\n\n.rtd-btn-cancel:hover:not(:disabled) {\n  background: #f9fafb;\n}\n\n.rtd-btn-confirm {\n  background: #dc2626;\n  border: none;\n  color: #ffffff;\n}\n\n.rtd-btn-confirm:hover:not(:disabled) {\n  background: #b91c1c;\n}\n\n.rtd-btn-cancel:disabled,\n.rtd-btn-confirm:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Slide-in animation */\n@keyframes rtdDrawerIn {\n  from {\n    transform: translateX(100%);\n    opacity: 0.98;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n@media (max-width: 600px) {\n  .rtd-shell {\n    width: 100vw;\n    border-radius: 0;\n  }\n}\n\n/* ═══ DARK THEME — ReleaseTableDrawer ═══ */\n.dark .rtd-shell {\n  background: #1e293b;\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.5);\n}\n.dark .rtd-header { border-bottom-color: #334155; }\n.dark .rtd-supertitle { color: #64748b; }\n.dark .rtd-title    { color: #f1f5f9; }\n.dark .rtd-close    { color: #64748b; }\n.dark .rtd-close:hover { background: #334155; color: #e2e8f0; }\n.dark .rtd-icon-wrap { background: #4c0519; }\n.dark .rtd-confirm-title { color: #f1f5f9; }\n.dark .rtd-confirm-sub   { color: #94a3b8; }\n.dark .rtd-btn-cancel {\n  background: #1e293b;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n.dark .rtd-btn-cancel:hover:not(:disabled) { background: #334155; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
